import { api2 , apiUpload } from './ApiService';

export default class CardPackageService {
    

    static async search(key,page,perpage){
        let data ={
            key: key,
            page: page,
            perpage:perpage
        }
        let response =  await api2.post(`/api/v1/card/package/search`,data)
        return response.data
    }
 
    static async create(data){
        let response = await apiUpload.post(`/api/v1/card/package/create`,data)
        return response.data
    }
    static async update(data){
        let response = await apiUpload.post(`/api/v1/card/package/update`,data)
        return response.data
    }
    static async delete(data){
        let response = await api2.post(`/api/v1/card/package/delete`,data)
        return response.data
    }
    
}


// WEBPACK FOOTER //
// ./src/service/CardPackageService.js